const data = [
    { id: "LAVAR", name: "Lavar" },
    { id: "SECAR", name: "Secar" },
]

export default [...data]